import { useParams, useSearchParams } from "react-router-dom";
import { BookingWizardPage } from "./BookingWizardPage";
import { BookingWizardV2Page, shouldUseV2Wizard } from "./BookingWizardV2Page";

export const BookingEditPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const bookingId = id ? parseInt(id, 10) : undefined;
  const forceV2 = searchParams.get("v2") === "1";
  const useV2 =
    forceV2 || (bookingId != null && !Number.isNaN(bookingId) && shouldUseV2Wizard(bookingId));

  if (useV2) {
    return <BookingWizardV2Page />;
  }

  return <BookingWizardPage />;
};
